import { useQuery } from "@tanstack/react-query";
import { createFileRoute, useParams, useSearch } from "@tanstack/react-router";
import z from "zod";
import { ticketQueryOptions } from "@/services/ticket/ticket.options";
import { OrgTicketTypeFullIndexTabContent } from "./OrgTicketTypeFullPage";

const FULL_INDEX =
	"/_authenticated/(org-app)/_orgAdmin/org-admin/$orgId/configuration/ticketTypes/$ticketTypeId/full/" as const;

const FULL_PARENT =
	"/_authenticated/(org-app)/_orgAdmin/org-admin/$orgId/configuration/ticketTypes/$ticketTypeId/full" as const;

export const Route = createFileRoute(FULL_INDEX)({
	component: OrgTicketTypeFullIndexRoute,
	params: {
		parse: (raw) => {
			const p = raw as { orgId: string; ticketTypeId: string };
			return {
				orgId: z.string().parse(p.orgId),
				ticketTypeId: z.string().parse(p.ticketTypeId),
			};
		},
	},
});

function OrgTicketTypeFullIndexRoute() {
	const params = useParams({ from: FULL_PARENT });
	const search = useSearch({ from: FULL_PARENT });

	const detailQuery = useQuery(
		ticketQueryOptions.ticketTypeDetail(params.ticketTypeId, {
			organizationId: params.orgId,
		}),
	);

	const ticketType = detailQuery.data ?? null;

	if (!ticketType) {
		return null;
	}

	return (
		<OrgTicketTypeFullIndexTabContent
			tab={search.tab}
			ticketType={ticketType}
			organizationId={params.orgId}
		/>
	);
}
